import { InferType, object, string } from 'yup';

import Num from '@flipster/utils/num';

export const ConvertFormCustomError = {
  NO_AVAILABLE_ASSET: 'NO_AVAILABLE_ASSET',
  CONVERTIBLE_BALANCE_EXCEEDED: 'CONVERTIBLE_BALANCE_EXCEEDED',
  MININUM_CONVERSION_AMOUNT: 'MININUM_CONVERSION_AMOUNT',
  AVAILABLE_BALANCE_EXCEEDED: 'AVAILABLE_BALANCE_EXCEEDED',
} as const;

export const convertFormValidator = object({
  fromCurrency: string().required(),
  toCurrency: string().required(),
  fromAmount: string()
    .test({
      skipAbsent: true,
      test(value, ctx) {
        const { fromMinAmount, fromMaxAmount } = ctx.parent;
        if (!value || !fromMinAmount || !fromMaxAmount) return true;
        /** fromAmount가 0이어서 convert할 수 있는 amount가 없을 때 */
        if (Num(fromMaxAmount).isEqualTo(0))
          return ctx.createError({ type: 'custom', message: ConvertFormCustomError.NO_AVAILABLE_ASSET });
        /** fromAmount가 최소 convert amount보다 작을 때 */
        if (Num(value).isLessThan(fromMinAmount)) {
          return ctx.createError({
            type: 'custom',
            message: ConvertFormCustomError.MININUM_CONVERSION_AMOUNT,
          });
        }
        /** from amount input에 입력한 금액이 가지고 있는 from amount보다 클 때 */
        if (Num(value).isGreaterThan(fromMaxAmount)) {
          return ctx.createError({
            type: 'custom',
            message: ConvertFormCustomError.CONVERTIBLE_BALANCE_EXCEEDED,
          });
        }
        return true;
      },
    })
    .required(),
  toAmount: string()
    .test({
      skipAbsent: true,
      test(value, ctx) {
        const { toCurrencyAvailableBalance } = ctx.parent;
        if (!value || !toCurrencyAvailableBalance) return true;
        /** to amount input에 입력한 금액이 convertible balance보다 클 때 */
        if (Num(value).isGreaterThan(toCurrencyAvailableBalance)) {
          return ctx.createError({
            type: 'custom',
            message: ConvertFormCustomError.AVAILABLE_BALANCE_EXCEEDED,
          });
        }
        return true;
      },
    })
    .required(),
  // for validation
  fromMinAmount: string(),
  fromMaxAmount: string(),
  toCurrencyAvailableBalance: string(),
  // preview value
  currencyConversionId: string(),
  initFromAmount: string(),
  initToAmount: string(),
  initExchangeRate: string(),
});

export type ConvertFormSchema = InferType<typeof convertFormValidator>;
